module.exports = __webpack_public_path__ + "img/312x630.90eefe0c.png";